//
//
//
//
//
//
//
//
//
//

import CvView from "./view.vue";
import CvViewMob from "./viewMob.vue";

export default {
  name: "curriculum",
  components: { CvView, CvViewMob },
  mounted() {
    window.scrollTo(0, 0);
  },
};
